import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { RestService } from 'src/app/services/rest.service';
import { GlobalvarsService } from 'src/app/services/globalvars.service';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  users: any[] = [];

  constructor(
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let tmpToken:any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getUsers(tmpToken.accessToken)
      .then(value => {
        this.users.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  edit(itemId:any) {
    this.router.navigateByUrl('/users/' + itemId);
  }

  add() {
    this.router.navigateByUrl('/users/add/');
  }
}
